import React from 'react';
import { IAnalyticRubricCriterion } from '@/components/staffer/ExerciseBuilder/Rubric/useQuestionRubric';
import cn from '@/utils/cn';
import I18n from 'i18n-js';
import { TEXT_AREA_CLASSES, TEXT_AREA_CSS } from './AnalyticRubric.utils';

export type EditorCriterionCellProps = {
  data: IAnalyticRubricCriterion;
  locale?: Lowercase<Locale>;
  onCriterionNameChange: (criterionIndex: number, newName: string) => void;
  rowIndex: number;
};

const EditorCriterionCell = ({
  data,
  locale,
  onCriterionNameChange,
  rowIndex,
}: EditorCriterionCellProps) => {
  const criterionName = locale === 'en' ? data.name_en : data.name_es;

  return (
    <textarea
      className={cn(
        TEXT_AREA_CLASSES,
        'tw-bg-light-grey tw-font-semibold placeholder:tw-font-normal placeholder:tw-text-gray-400',
      )}
      placeholder={I18n.t('enter_text', { locale })}
      style={TEXT_AREA_CSS}
      value={criterionName}
      onChange={e => onCriterionNameChange(rowIndex, e.target.value)}
    />
  );
};

export default EditorCriterionCell;
